TS.ns('WL');

WL.documentAutomaticTransitionModel = new Class({
    Extends: TS.domain.EditDomain,

    initialize: function (config) {
        var me = this;

        me.parent(config);
    },

    createProperties: function (config) {
        var me = this;

        me.parent(config);

        me.canEditModel = ko.computed(function () {
            if (me.ReadOnly())
                return false;
            return true;
        });

        var detailList = me.getDomainProperty('gridDetail_Property');

        if (detailList) {
            cat = detailList.Commands;

            newCmd = new TS.domain.Command();
            newCmd['Code'] = 'AddDetail';
            newCmd['Text'] = me.AddActionCommandText;
            newCmd['handler'] = '_addDetail';
            newCmd['IconCode'] = 'plus';
            newCmd.InternalVisible = me.canEditModel;
            cat.push(newCmd);
        }
    },

    _addDetail: function () {
        var me = this; 

        me.performServerCommand({ cmd: 'AddDetail', submitModel: true, extraData: {}, blockUI: true });
    }
});
